export const isLocalhost = () => window.location.host.toLowerCase().includes('localhost');

/** Remote environments that are explicitly not production. */
const NON_PROD_API_URLS = new Set(['https://regression.thegreco.com/api', 'https://sandbox.thegreco.com/api']);

const LOOPBACK_HOSTS = ['localhost', '127.0.0.1', '::1', '[::1]'];

/**
 * True when the configured API is known not to be production. Any loopback API is a container
 * or a local build, so it counts regardless of port.
 */
export const isNonProdApi = (apiUrl: string): boolean => {
  if (NON_PROD_API_URLS.has(apiUrl)) return true;

  try {
    return LOOPBACK_HOSTS.includes(new URL(apiUrl).hostname);
  } catch {
    // A relative baseUrl ('/api') is same-origin, so it is prod exactly when the page is.
    return false;
  }
};
